import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input } from 'reactstrap';

function CustomSelect({ label, className, onChange, name, value, placeholder, invalid, options, notEmptyValue }) {
  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <Input className={className} onChange={onChange} name={name} value={value} placeholder={placeholder} invalid={invalid} bsSize='md' type='select'>
      {!notEmptyValue && <option key={999} value={null}></option>}
        {options.map((option, index) => {
          return (
            <option key={index} value={option.id} name={option.name}>
              {option.name}
            </option>
          );
        })}
      </Input>
    </FormGroup>
  );
}

CustomSelect.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  invalid: PropTypes.bool,
  options: PropTypes.array
};

export default CustomSelect;
